import { useEffect, useMemo, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DictionaryRepository from '@/creditflowresearch/infrastructure/repository/DictionaryRepository';
import { useCorporateBondScreenerSidebarFilterContext } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import mapToCheckboxOptions from '@/creditflowresearch/application/BondScreener/mapToCheckboxOptions';

const useListingSection = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const repository = getContainer().get(DictionaryRepository);
  const [dictionary, setDictionary] = useState([]);

  useEffect(() => {
    const loadDictionary = async () => {
      setDictionary(await repository.getListings());
    };
    loadDictionary();
  }, []);

  const items = useMemo(
    () => mapToCheckboxOptions(filters?.listingIds, dictionary),
    [dictionary, filters?.listingIds],
  );

  return useCheckboxFilter({ filterKey: 'includedListingIds', items });
};

export default useListingSection;
